import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import CssHelper from "../../../../core/utils/cssHelper.js";
import ChartUtil from "../timeseries-chart/chart-util.js";
import styles from "../timeseries-chart/chart.scss";

const LineBarChartComponentController = require('./controller.js');

export default class Chart extends BaseComponent {

  constructor(props) {
    super(props);
    this.cssSheet = document.styleSheets[1];
    this.deleteEpochChartCategoryColoringCSS(this.cssSheet);

    let divId = '#' + this.props.widgetId + "-" + this.props.componentModel.controller.id;
    let legends = this.props.legends;
    let categoryNumber = 1;
    for (let i in legends) {
      if (legends[i].parameters != null) {
        let selector = divId + ".epoch.category10 .category" + categoryNumber + " .line";
        let style = "stroke: " + legends[i].parameters.legendColor + ";";
        CssHelper.addCSSRule(selector, style, 0);

        selector = divId + ".epoch.category10 .bar.category" + categoryNumber;
        style = "fill: " + legends[i].parameters.legendColor + ";";
        CssHelper.addCSSRule(selector, style, 0);

        categoryNumber++;
      }
    }
  }

  componentDidMount() {
    this.componentController = new LineBarChartComponentController(
      this.props.componentModel.controller,
      this.props.widgetId,
      this.props.legends);

    WidgetService.addComponentToWidget(this.props.widgetId, this.componentController);

    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.resizeWidget(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.resizeWidget(payload));
  }

  componentWillUnmount() {
    this.componentController.destroy();
    // remove chart specific CSS rules that were added to color epoch chart
    this.deleteEpochChartCategoryColoringCSS(this.cssSheet);

    this.unsubscribeAll();
  }

  deleteEpochChartCategoryColoringCSS(cssSheet) {
    // let divId = this.props.widgetId + "-" + this.props.componentModel.controller.id;
    // CssHelper.deleteEpochChartCategoryColoringCSS(divId + '.epoch.category10');
  }

  resizeWidget(data) {
    
    let widget = data.widget;
    let newHeight = data.height || $(widget).height();
    let newWidth = data.width || $(widget).width();
    let widgetId = $(widget.children("div")[0]).attr("id");
  
    if (this.props.widgetId === widgetId) {
      ChartUtil.resizeCharts(widgetId, newHeight, newWidth);
    }
  }

  render() {
    let divId = this.props.widgetId + "-" + this.props.componentModel.controller.id;
    return (
      <div id={divId} className={["epoch category10 chart-widget-main-chart", styles.container].join(" ")}>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/line-static-chart/chart.jsx